import { Component, OnInit } from '@angular/core';
import { ThemeService } from '@/core/services/theme.service';
import { AuthService } from '@/core/services/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { AngularTranslations } from '@/core/types/angular-primeng-api';

@Component({
    selector: 'app-auth-page',
    standalone: false,
    template: `
        <main class="auth">
            <section
                class="min-h-screen flex items-center lg:items-start lg:py-20 justify-center animate-fadein animate-duration-300 animate-ease-in max-w-400 mx-auto"
            >
                <div class="flex w-full h-full justify-center gap-12">
                    <div class="flex flex-col md:py-20 md:min-w-md md:max-w-md md:w-md max-w-md">
                        <a routerLink="/" class="flex items-center justify-center mb-16">
                            <div class="logo"></div>
                        </a>
                        <div class="flex flex-col justify-center grow">
                            <div class="max-w-md mx-auto w-full">
                                <router-outlet></router-outlet>
                            </div>
                        </div>
                        <div class="mt-16 text-center block relative text-sm text-surface-400 dark:text-surface-500">
                            <a class="text-inherit" target="_blank" rel="noopener" [href]="footerImprintUrl">
                                {{ footerImprintText }},
                            </a>
                            <a class="text-inherit" target="_blank" rel="noopener" [href]="footerPrivacyUrl">
                                {{ footerPrivacyText }}
                            </a>
                            &
                            <a class="text-inherit" target="_blank" rel="noopener" [href]="footerTermsUrl">
                                {{ footerTermsText }}
                            </a>
                        </div>
                    </div>
                    <!-- Optional, display image for desktop view <div class="hidden h-full lg-flex"></div> -->
                </div>
            </section>
        </main>
    `,
    styles: ``,
})
export class AuthPageComponent implements OnInit {
    isLoading = false;
    // Note: Using | translate in the template causes a race condition in Angular's change detection.
    //       This is not necessarily causing a bug, but it prints a console error log in dev mode.
    //       Performing the translation in ngOnInit fixes this issue.
    footerImprintUrl = '';
    footerPrivacyUrl = '';
    footerTermsUrl = '';
    footerImprintText = '';
    footerPrivacyText = '';
    footerTermsText = '';

    constructor(
        private readonly themeService: ThemeService,
        private readonly authService: AuthService,
        private readonly translate: TranslateService,
    ) {
        this.authService.loggedIn$.subscribe((isLoggedIn) => {
            if (!isLoggedIn) {
                this.themeService.useSystemTheme = true;
                this.themeService.configureTheme();
            }
        });
    }

    public ngOnInit(): void {
        this.translate
            .get([
                'public_imprint_URL',
                'public_privacy_URL',
                'public_tos_URL',
                'public_imprint',
                'public_privacy',
                'public_tos',
            ])
            .subscribe((translations: AngularTranslations) => {
                this.footerImprintUrl = translations['public_imprint_URL'];
                this.footerTermsUrl = translations['public_tos_URL'];
                this.footerPrivacyUrl = translations['public_privacy_URL'];
                this.footerImprintText = translations['public_imprint'];
                this.footerPrivacyText = translations['public_privacy'];
                this.footerTermsText = translations['public_tos'];
            });
    }
}
